import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router";
import {
  Button,
  Typography,
  type TypographyVariant,
} from "@platform/design-system";

type BackNavigationButtonProps = {
  label: string;
  route: string;
  variant?: TypographyVariant;
};

export const BackNavigationButton: React.FC<BackNavigationButtonProps> = ({
  label,
  route,
  variant,
}) => {
  const navigate = useNavigate();

  return (
    <Button
      variant="tertiary"
      size="sm"
      onClick={() => navigate(route)}
      startIcon={<ChevronLeftIcon />}
      sx={{ width: "fit-content" }}
    >
      <Typography color="inherit" variant={variant}>
        <strong>BACK TO {label}</strong>
      </Typography>
    </Button>
  );
};
